export default __webpack_public_path__ + "static/media/abstracto1.39173514.jpg";